import { render, staticRenderFns } from "./FoldingPanel.vue?vue&type=template&id=87fedb06&"
import script from "./FoldingPanel.vue?vue&type=script&lang=ts&"
export * from "./FoldingPanel.vue?vue&type=script&lang=ts&"
import style0 from "./FoldingPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports